<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template :id="graph_data['y'][0]">
  <div v-if="show" class="black--text pa-0 ma-0">
    <vue-plotly :data="plotData" :layout="layout" :options="options" class="pa-0 ma-0" />
  </div>
  <div v-else class="align-center">
    <v-img
      class="align-center"
      max-height="100"
      max-width="65"
      src="/reo_pics/error.png"
    ></v-img>
  </div>
</template>

<script>
  import VuePlotly from '@statnett/vue-plotly';
  import {mapGetters} from 'vuex';
  import {config} from '@/store/config';

  export default {
    name: 'abs_export_year',
    components: {
      VuePlotly,
    },
    props: {
      graph_data: Object,
    },
    computed: {
      ...mapGetters(['getDsmAppState', 'app_data', 'single_product', 'home_market_code']),
      color() {
        if (this.graph_data['secondary_title'].includes('trade balance')) {
          return this.graph_data['y'].map(v =>
            v < 0 ? config.plot_bar_red : config.plot_blue,
          );
        } else {
          return this.graph_data['y'].map(() =>
            this.graph_data['secondary_title'].includes('import')
              ? config.plot_bar_red
              : config.plot_blue,
          );
        }
      },
      plotData: function () {
        if (this.graph_data !== null) {
          return [
            {
              y: this.graph_data['y'].map(
                v => v / this.app_data.value_mulitplier['divider'] / 1000,
              ),
              x: this.graph_data['x'],
              type: 'bar',
              marker: {
                color: this.color,
              },
            },
          ];
        } else {
          return {};
        }
      },
      show: function () {
        // return this.$store.getters.historyPlotDataTotal['x'][0] > 1 ? true : false;
        return this.graph_data !== undefined;
      },
      layout: function () {
        return {
          title: {
            automargin: true,
            text:
              this.graph_data['main_title'] + '<br>' + this.graph_data['secondary_title'],
            font: {
              size: 11,
              color: 'black',
            },
            yref: 'container',
            x: 0.5,
            y: 0.94,
            yanchor: 'bottom',
            pad: {
              b: 10,
            },
          },
          height: '320',
          autosize: true,
          margin: {
            l: 50,
            r: 0,
            b: 90,
            t: 65,
            pad: 5,
          },

          xaxis: {
            automargin: true,
            tickmode: 'linear',
            tickfont: {
              size: 9,
            },
          },
          yaxis: {
            title: '',
            rangemode: 'tozero',
            tickfont: {
              size: 10,
            },
          },
          legend: {
            orientation: 'h',
            font: {size: 9},
            automargin: true,
          },
          annotations: [
            {
              x: '0',
              y: '1.15',
              xref: 'paper',
              yref: 'paper',
              xanchor: 'left',
              yanchor: 'top',
              text:
                this.app_data.value_mulitplier['prefix'] +
                ' ' +
                this.graph_data['currency'],
              showarrow: false,
            },
            {
              xref: 'paper',
              yref: 'paper',
              x: 0,
              y: 'quarterly' in this.graph_data ? -0.4 : -0.2,
              xanchor: 'left',
              yanchor: 'bottom',
              text: this.graph_data['source'],
              showarrow: false,
              font: {
                family: 'Arial',
                size: 8,
                color: 'rgb(150,150,150)',
              },
            },
            // {
            //   xref: 'paper',
            //   yref: 'paper',
            //   x: 0.39,
            //   y: 'quarterly' in this.graph_data ? -0.36 : -0.11,
            //   xanchor: 'center',
            //   yanchor: 'top',
            //   text: 'Source: Trade Research Advisory, calculated from Australian Bureau of Statistics (ABS)',
            //   showarrow: false,
            //   font: {
            //     family: 'Arial',
            //     size: 8,
            //     color: 'rgb(150,150,150)',
            //   },
            // },
          ],
        };
      },
    },
    methods: {},
    data: function () {
      return {
        options: {
          responsive: true,
          displayModeBar: false,
        },
      };
    },
  };
</script>
